__webpack_require__.p = "https://cdn.foundries.io/app/main/";